import React, { useMemo } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBookOpen, FiLayers, FiActivity } = FiIcons;

function SummaryCards({ curriculum = [] }) {
  const summaries = useMemo(() => {
    const lessons = (curriculum || []).flatMap((group) => (
      (group.lessons || []).map((lesson) => ({
        ...lesson,
        subject: group.subject
      }))
    ));
    const touchedLessons = lessons.filter((lesson) => (
      lesson.status === 'completed' || lesson.status === 'in-progress'
    ));
    const sessionCount = touchedLessons.reduce(
      (total, lesson) => total + (Number(lesson.sessionCount) || 0),
      0
    );
    const subjectCounts = touchedLessons.reduce((counts, lesson) => ({
      ...counts,
      [lesson.subject]: (counts[lesson.subject] || 0) + 1
    }), {});
    const recentLesson = [...touchedLessons]
      .filter((lesson) => lesson.activityOrder !== null && lesson.activityOrder !== undefined)
      .sort((first, second) => first.activityOrder - second.activityOrder)[0];
    const hasActivity = touchedLessons.length > 0;
    const recentValue = hasActivity
      ? (recentLesson?.lastActivity?.split(',')[0] || 'Recent')
      : 'None';
    const recentDetail = recentLesson?.lastActivity
      ? `${recentLesson.lastActivity.split(',').slice(1).join(',').trim()} · ${recentLesson.title}`
      : 'No activity yet';

    return [
      {
        label: 'Sessions this week',
        value: String(sessionCount),
        detail: hasActivity
          ? `${touchedLessons.length} active topics`
          : 'No activity yet',
        icon: FiBookOpen
      },
      {
        label: 'Topics touched',
        value: String(touchedLessons.length),
        detail: hasActivity
          ? `${subjectCounts.Math || 0} math · ${subjectCounts.Science || 0} science`
          : 'No activity yet',
        icon: FiLayers
      },
      {
        label: 'Recent activity',
        value: recentValue,
        detail: recentDetail,
        icon: FiActivity
      }
    ];
  }, [curriculum]);

  return (
    <div className="summary-grid">
      {summaries.map((summary) => (
        <article className="summary-card" key={summary.label}>
          <span className="summary-icon">
            <SafeIcon icon={summary.icon} />
          </span>
          <div>
            <p>{summary.label}</p>
            <strong>{summary.value}</strong>
            <small>{summary.detail}</small>
          </div>
        </article>
      ))}
    </div>
  );
}

export default SummaryCards;
